export const getTransitionDelayTime = (idx) => `${((idx * 0.50) + 0.15) * 1000}ms`;